import { hasAnalyticsConsent } from './cookie-consent';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/** Adds one GA4 event to GTM's data layer after analytics consent. */
export function pushAnalyticsEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>,
) {
  if (typeof window === 'undefined' || !hasAnalyticsConsent() || !window.dataLayer) return;
  window.dataLayer.push({ event: eventName, ...params });
  window.gtag?.('event', eventName, params ?? {});
}
